import React from 'react';
// Static info bar. No countdown or timers. Never a price here (rule: no price in the top bar).
export function InfoBar() {
  return <div className="w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-183" data-mp="2fieggpnpknyl">
      <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-medium sm:text-sm" data-id="element-184" data-mp="2jietc5v5sr3j">
        <span className="sm:hidden" data-id="element-185" data-mp="2ojm1w754lub9">Jednorazowa płatność · 7 dni gwarancji</span>
        <span className="hidden sm:inline" data-id="element-186" data-mp="2ti5om9rjna4o">Jednorazowa płatność · Dostęp od razu · 7 dni gwarancji</span>
      </p>
    </div>;
}